/* global jQuery COMPONENTS */

COMPONENTS.ComponentGallery = (function ($) {
  function ComponentGallery () {
    this.$component = $('[data-ecs-component="component-gallery"]')
    this.$grid = this.$component.find('[data-ecs-components-control="gallery"]')
    this.$filterSelect = this.$component.find('[data-ecs-gallery-element="gallery-filter-control"]')
    this.$filterButtons = this.$component.find('[data-ecs-components-control="gallery-filter-button"]')
    this.$filterType = this.$component.find('[data-components-control="gallery-navigation"]').attr('data-components-control-type')
    this.$firstSelect = this.$component.find('select[data-ecs-gallery-control="gallery-filter-select"]')
    this.$mediaSelect = this.$component.find('select[data-ecs-gallery-control="gallery-filter-type"]')
    this.$allButton = this.$component.find('[data-ecs-components-gallery-filter="*"]')
    this.$galleryItems = this.$component.find('[data-ecs-components-control="gallery-item"]')

    this.$firstFilter = ''
    this.$mediaFilter = ''

    this.gridOpts = {
      itemSelector: '[data-ecs-components-control="gallery-item"]',
      layoutMode: 'masonry',
      filter: this.$firstFilter
    }
  }

  // Applies backup attributes to gallery items so that 'All' category opens in one fancybox modal
  ComponentGallery.prototype.recordGallery = function ($request) {
    const component = this

    if ($request == 'all') {
      $(component.$galleryItems).each(function () {
        $(this).children('[data-fancybox]').attr('data-fancybox', '*')
      })
    } else if ($request == 'native') {
      $(component.$galleryItems).each(function () {
        const nativeGallery = $(this).children('[data-fancybox]').attr('data-ecs-gallery')
        $(this).children('[data-fancybox]').attr('data-fancybox', nativeGallery)
      })
    }
  }

  // Set active gallery for gallery item links based on selected
  ComponentGallery.prototype.setGallery = function ($selected) {
    const component = this

    if ($selected == '*') { // If category selected is 'All'
      component.recordGallery('all')
    } else {
      component.recordGallery('native')
    }
  }

  ComponentGallery.prototype.setFilter = function () {
    const component = this
    component.$firstFilter = component.$firstSelect.children(':selected').data('ecs-components-gallery-filter')
    component.$mediaFilter = component.$mediaSelect.children(':selected').data('ecs-components-gallery-filter')

    if (this.$filterType === 'buttons') {
      component.$firstFilter = this.$component.find('[data-ecs-components-control="gallery-filter-button"]').first().attr('data-ecs-components-gallery-filter')
    }

    if (typeof component.$mediaFilter != 'undefined') {
      if (component.$mediaFilter !== '*' && component.$firstFilter !== '*') {
        component.gridOpts.filter = component.$mediaFilter + component.$firstFilter
      } else if (component.$mediaFilter === '*' || component.$firstFilter === '*') {
        component.gridOpts.filter = (component.$mediaFilter + component.$firstFilter).replace('*', '')
      }
    } else {
      component.gridOpts.filter = component.$firstFilter
    }

    const params = (new URL(document.location)).searchParams
    const searchParams = new URLSearchParams(params)

    if (searchParams.has('cat')) {
      component.gridOpts.filter = searchParams.get('cat')

      component.$filterButtons.each(function () {
        $(this).removeClass('btn--active')
      })

      $('button[data-ecs-components-gallery-filter="' + searchParams.get('cat') + '"]').addClass('btn--active')
    }
  }

  ComponentGallery.prototype.doFilter = function () {
    const component = this
    component.$grid.isotope(this.gridOpts)
  }

  ComponentGallery.prototype.init = function () {
    const component = this

    if (component.$grid.length > 1) {
      return
    }

    component.$filterSelect.each(function () {
      $(this).change(function () {
        component.setFilter()
        component.doFilter()
        component.setGallery(component.gridOpts.filter)
      })
    })

    component.$filterButtons.each(function () {
      const $button = jQuery(this)

      $button.click(function () {
        const filter = $(this).data('ecs-components-gallery-filter')

        component.$filterButtons.each(function () {
          $(this).removeClass('btn--active')
        })

        $button.addClass('btn--active')
        component.gridOpts.filter = filter
        component.doFilter()

        component.setGallery(filter)
      })
    })

    component.setFilter()
    if (component.$grid.length >= 1) {
      this.$grid.imagesLoaded(function () {
        component.doFilter()
      })
    }
    component.setGallery(component.gridOpts.filter)
  }

  return ComponentGallery
})(jQuery)

document.addEventListener('components_init', function () {
  // Hook into the main components init
  COMPONENTS.componentGallery = new COMPONENTS.ComponentGallery()
  COMPONENTS.componentGallery.init()
})
